import { ElementRef, EventEmitter, Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class DatePickerController {

    public active: boolean = false;
    public position;
    public el: ElementRef;
    public emitter: EventEmitter<any>;


    constructor() {
    }

    show(el: ElementRef, emitter) {
        this.active = true;
        this.position = el.nativeElement.getBoundingClientRect()
        this.emitter = emitter;
    }
}
